import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
};

// Ajout du measurementId si présent dans l'env
if (process.env.REACT_APP_FIREBASE_MEASUREMENTID) {
  firebaseConfig.measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENTID;
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
console.log("[FB] storageBucket:", app.options.storageBucket);
// Expose UID for debug logs (uploads)
try {
  onAuthStateChanged(auth, (u) => {
    try { if (typeof window !== 'undefined') window.__uid = u?.uid || null; } catch {}
  });
} catch {}
export default app;
export const db = getFirestore(app);
// Force bucket to avoid mis-parsed env or wrong domain
export const storage = getStorage(app, "gs://talk-mate-backend.appspot.com");

// Analytics (ne s'initialise que dans un environnement navigateur)
let analytics = null;
try {
  if (typeof window !== "undefined" && typeof document !== "undefined" && firebaseConfig.measurementId) {
    analytics = getAnalytics(app);
  }
} catch (e) {
  console.warn("[FB] analytics init skipped:", e?.message || e);
}
export { analytics };
